import {lazy} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Route, Switch} from 'react-router-dom'
import {RootState} from '../../../setup'
import {Container} from '../../modules/components'
import {Error403Forbidden} from '../../pages/errors/Error403Forbidden'
import {PermissionPagesEnum} from '../../shared/enums'

export enum FinancialRoutesEnum {
    DatatableOrders = '/financeiro/pedidos',
    ShowOrder = '/financeiro/pedidos/:id',
    DatatableCards = '/financeiro/cartoes',
    DatatableInvoices = '/financeiro/faturas',
    ShowInvoice = '/financeiro/faturas/:id',
    DatatableNfses = '/financeiro/nf-recebidas',
}

export default function FinancialRouter() {
    const permissionPages: number[] = useSelector<RootState>(
        ({auth}) => auth.permission_pages,
        shallowEqual
    ) as number[]

    /*Rotas para Pedidos*/
    const DatatableOrders = lazy(() => import('../../pages/financial/orders/DatatableOrders'))
    const ShowOrder = lazy(() => import('../../pages/financial/orders/ShowOrder'))

    /*Rotas para Cartões*/
    const DatatableCards = lazy(() => import('../../pages/financial/cards/DatatableCards'))

    /*Rotas para Pedidos*/
    const DatatableInvoices = lazy(() => import('../../pages/financial/invoices/DatatableInvoices'))
    const ShowInvoice = lazy(() => import('../../pages/financial/invoices/ShowInvoice'))

    /*Rotas para Pedidos*/
    const DatatableNfses = lazy(() => import('../../pages/financial/nfses/DatatableNfses'))

    return (
        <Container loading={permissionPages === undefined}>
            <Switch>
                <Route
                    path={FinancialRoutesEnum.ShowOrder}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialOrders)
                            ? ShowOrder
                            : Error403Forbidden
                    }
                />
                <Route
                    path={FinancialRoutesEnum.DatatableOrders}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialOrders)
                            ? DatatableOrders
                            : Error403Forbidden
                    }
                />
                <Route
                    path={FinancialRoutesEnum.DatatableCards}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialCards)
                            ? DatatableCards
                            : Error403Forbidden
                    }
                />
                <Route
                    path={FinancialRoutesEnum.ShowInvoice}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialInvoices)
                            ? ShowInvoice
                            : Error403Forbidden
                    }
                />
                <Route
                    path={FinancialRoutesEnum.DatatableInvoices}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialInvoices)
                            ? DatatableInvoices
                            : Error403Forbidden
                    }
                />
                <Route
                    path={FinancialRoutesEnum.DatatableNfses}
                    component={
                        permissionPages?.includes(PermissionPagesEnum.FinancialNfses)
                            ? DatatableNfses
                            : Error403Forbidden
                    }
                />
            </Switch>
        </Container>
    )
}
